
/*
    All of the API interactions related to trips and the
    metadata for them

    Includes requests for data, creation, editing,
    as well as running announcements
    or departing
*/

import axios from "axios";
import BaseValues from "./BaseValues";

import { formatDateTime, getTimeStringFromDate } from "../Scripts/Utilities";

//
// get all trips matching the filter parameters
//
export const getTrips = (params, mode) => {

    console.log("ROUTES", params, params.routesSelected);

    const data = BaseValues.createFormData({
        location: params.location,
        fromdate: `${BaseValues.createDateString(params.startDate)} ${params.startTime}`,
        todate: `${BaseValues.createDateString(params.endDate)} ${params.endTime}`,
        DEPARTED: "ALL", // (mode === "REASSIGNED" || mode === "NOT-DEPARTED") ? "ALL": mode,
        route: params.routesSelected.join(","),
        gate: params.lanesSelected.join(","),
        lookBehind: params.lookBehind,
        lookAhead: params.lookAhead,
        has_driver: "ALL"
    });

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getTrips`;

    var config = {
        method: 'post',
        url,
        data
    };

    if(mode === "REASSIGNED"){
        return axios(config)
                .then(({data}) => {
                    // filter to only show the records which are involved
                    // with a reassignment: unused, unfilled, merged
                    console.log("REASSIGNED INTERCEPTED", data);

                    const ret = {}; 
                    
                    ret.data = data.filter(d => {
                        return d.driver_reassigned || d.driver_replaced;
                    });

                    return ret;
                })
                .catch(BaseValues.handleError);
    }
    else{
        return axios(config).catch(BaseValues.handleError);
    }
}

//
// get the time points for a single trip
//
export const getTimePoints = (params) => {

    const data = BaseValues.createFormData({
        internal_trip_number: params.TripNumber,
        departure_time: params.SchedDepTime
    });

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getTripStops`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get list of possible destinations based on a route 
//
export const getDestinations = (params) => {
    const data = BaseValues.createFormData({
        route: params.route    
    });

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getDestinations`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get the stops for a destination
//
export const getStopsForDestination = (params) => {
    console.log("get Stops for Destination params", params);
    const data = BaseValues.createFormData({
        route: params.route,
        busheadercode: params.BusHeaderCode,
        direction: params.Direction
    });

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getstops`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get a list of general delay reasons
//
export const getDelayReasons = (params) => {
    const data = BaseValues.createFormData({});

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getDelayReasons`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// depart a trip
//
export const departBus = (params) => {

    console.log("BUS DEPART PARAMS", params);

    const translation = {
        timepoint: params.TimePoint,
        scheddeptime: params.SchedDepTime,
        internal_trip_number: params.TripNumber,
        lane: params.lane,
        vehicle_id: params.vehicleID,
        pass_on_arrival: params.arrivals,
        pass_getting_off: params.gettingOff,
        pass_boarding: params.boarding,
        pass_left_behind: params.leftBehind,
        pass_on_departure: params.onDeparture,
        delay_reason: params.reasonSelected || "",
        delay_comment: params.comment || ""
    };

    console.log("DEPARTURE TRANSLATION", translation);

    const data = BaseValues.createFormData(translation);
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/departbus`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// update a trip record
//
export const updateTripStatus = (params) => {
    const translation = {
        timepoint: params.TimePoint,
        scheddeptime: params.SchedDepTime,
        // actual_departure_time: formatDateTime(params.SchedDepTime, params.time),
        ActDepTime: params.time ? formatDateTime(params.SchedDepTime, params.time) : "",
        internal_trip_number: params.TripNumber,
        lane: params.lane,
        vehicle_id: params.vehicleID,
        pass_on_arrival: params.arrivals,
        pass_getting_off: params.gettingOff,
        pass_boarding: params.boarding,
        pass_left_behind: params.leftBehind,
        pass_on_departure: params.onDeparture,
        delay_reason: params.reasonSelected || "",
        delay_comment: params.comment || "",
        manual_delay: params.delay || ""
    };

    console.log("UPDATE TRANSLATION", translation);

    const data = BaseValues.createFormData(translation);
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/updatetrip`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// create a new trip record
//
export const addTrip = (params) => {

    const stops = params.timepoints.length > params.timepointsSelected.length ? params.timepointsSelected.map(v => v.TimePoint).join(",") : "";

    const translation = {
        departure_Time: params.SchedDepTime,
        new_Dep_Time: formatDateTime(params.SchedDepTime, params.schedule),
        lane: params.laneSelected,
        newrunnumber: params.run
    };

    const url = `${BaseValues.BaseURL}/api/BUSConsole/addCustomTrip`;

    if(stops !== ""){
        translation.stops = stops;
        translation.busheadercode = params.destinationSelected;
        translation.route = params.route;
    }
    else if(params.destChanged){
        translation.busheadercode = params.destinationSelected;
        translation.route = params.route;
    }
    else{
        translation.internal_trip_number = params.TripNumber;
    }

    console.log({url, translation});

    /*
route: "",
        run: 900,
        headsign: "",
        schedule: "",
        lanes: [],
        laneSelected: "",
        destinations: [],
        destinationSelected: "",
        timepoints: [],
        timepointsSelected: []
    */

    const data = BaseValues.createFormData(translation);

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get a new 900+ run number which hasn't yet been used
//
export const getNewRunNumber = (tripId) => {

    const url = `${BaseValues.BaseURL}/api/BUSConsole/generateNewRunNo`;

    const data = BaseValues.createFormData({tripnumber: tripId});

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
//
// ANNOUNCEMENTS
//
//

//
// run delayed announcement
//
export const runDelayedAnnouncement = (params) => {

    console.log("DELAYED ANNOUNCEMENT PARAMS", (params.LocationId === "NWKE"), params.LocationId, params);

    const valueToUse = (params.LocationId === "NWKE") ? params.TimePoint : params.LocationId;

    const translation = {
        // locationID: params.LocationId,
        locationID: valueToUse,
        // locationID: params.TimePoint,
        // locationName: "",
        carrierName: "New Jersey Transit",
        schedDepTime: getTimeStringFromDate(params.SchedDepTime),
        route: params.Route,
        destination: params.Header
    };

    console.log("TRANSLATION", translation);

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/TTS/sendDelayedTTS`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// run cancelled announcement
//
export const runCancelledAnnouncement = (params) => {

    const valueToUse = (params.LocationId === "MWKE") ? params.TimePoint : params.LocationId;

    const translation = {
        // locationID: params.LocationId,
        locationID: valueToUse,
        // locationID: params.TimePoint,
        // locationName: "",
        carrierName: "New Jersey Transit",
        schedDepTime: getTimeStringFromDate(params.SchedDepTime),
        route: params.Route,
        destination: params.Header
    };

    console.log("TRANSLATION", translation);

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/TTS/sendCancelledTTS`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// run boarding announcement
//
export const runBoardingAnnouncement = (params) => {

    const valueToUse = (params.LocationId === "MWKE") ? params.TimePoint : params.LocationId;

    const translation = {
        // locationID: params.TimePoint,
        locationID: valueToUse,
        // locationName: "",
        carrierName: "New Jersey Transit",
        schedDepTime: getTimeStringFromDate(params.SchedDepTime),
        route: params.Route,
        destination: params.Header,
        lane: params.ManualLaneGate ? params.ManualLaneGate : params.SchedLaneGate 
    };

    console.log("TRANSLATION", translation);

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/TTS/sendNowBoardingTTS`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// run lane change announcement
//
export const runLaneChangeAnnouncement = (params) => {

    const valueToUse = (params.LocationId === "MWKE") ? params.TimePoint : params.LocationId;

    const translation = {
        // locationID: params.LocationId,
        locationID: valueToUse,
        // locationID: params.TimePoint,
        // locationName: "",
        carrierName: "New Jersey Transit",
        schedDepTime: getTimeStringFromDate(params.SchedDepTime),
        route: params.Route,
        destination: params.Header,
        originalLane: params.SchedLaneGate,
        newLane: params.ManualLaneGate
    };

    console.log("TRANSLATION", translation);

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/TTS/sendLaneGateChangeTTS`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// change a trip status to hidden
//
export const hideTrip = (trip) => {

    console.log("hide trip", trip);

    const translation = {
        timepoint: trip.TimePoint,
        internal_trip_number: trip.TripNumber,
        scheddeptime: trip.SchedDepTime
    };

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/hidetrip`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// change a trip status to no-show
//
export const noShowTrip = (trip, reason) => {

    console.log("no show trip", trip);

    const translation = {
        timepoint: trip.TimePoint,
        internal_trip_number: trip.TripNumber,
        scheddeptime: trip.SchedDepTime,
        delayreasoncomment: reason
    };

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/noshowtrip`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// mark a trip as cancelled
//
export const cancelTrip = (trip, reason) => {

    console.log("cancel trip", trip);

    const translation = {
        timepoint: trip.TimePoint,
        internal_trip_number: trip.TripNumber,
        scheddeptime: trip.SchedDepTime,
        delayreasoncomment: reason
    };

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/canceltrip`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config); //.catch(BaseValues.handleError);
}

//
// mark a trip as delayed
//
export const delayTrip = (trip) => {

    console.log("delay trip", trip);

    const translation = {
        timepoint: trip.TimePoint,
        internal_trip_number: trip.TripNumber,
        scheddeptime: trip.SchedDepTime,
        delayreasoncomment: "",
        delay: 0 // hmm...
    };

    const data = BaseValues.createFormData(translation);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/delaytrip`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config);
}


